import {Fragment} from 'react';
import {Divider, Grid, Typography} from "@mui/material";
import {
    CAR_SHIPPING,
    CUSTOMS_BROKERAGE,
    HS_CODE_LOOKUP,
    LTL_FREIGHT,
    MOVING_SERVICE,
    PARCEL_PACKAGE
} from "../../Utils/Helper";

export const WordPressMultiConversationChatBotShippingInformation = ({lng, shippingInformation, service}) => {

    const listDataWithServiceCode = (shippingInformation, service) => {
        switch (service?.code) {
            case PARCEL_PACKAGE?.code:
                return (
                    <>
                        <Grid size={{xs: 4}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '描述' : 'Description'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 4}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '长 宽 高' : 'Length Width Height'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 3}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '重量' : 'Weight'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 1}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '数量' : 'Quantity'}
                            </Typography>
                        </Grid>
                        {
                            shippingInformation?.package?.map((each, index) => (
                                <Fragment key={index}>
                                    <Grid size={{xs: 4}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {lng === 'cn' ? '包裹' : 'Package'} {index + 1}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 4}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.length} {each?.width} {each?.height} {each?.dimension_unit}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 3}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.weight} {each?.weight_unit}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 1}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.quantity}
                                        </Typography>
                                    </Grid>
                                </Fragment>
                            ))
                        }
                    </>
                );
            case LTL_FREIGHT?.code:
                return (
                    <>
                        <Grid size={{xs: 4}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '描述' : 'Description'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 4}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '长 宽 高' : 'Length Width Height'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 3}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '重量' : 'Weight'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 1}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '数量' : 'Quantity'}
                            </Typography>
                        </Grid>
                        {
                            shippingInformation?.pallet?.map((each, index) => (
                                <Fragment key={index}>
                                    <Grid size={{xs: 4}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {lng === 'cn' ? '托盘' : 'Pallet'} {index + 1}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 4}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.length} {each?.width} {each?.height} {each?.dimension_unit}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 3}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.weight} {each?.weight_unit}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 1}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.quantity}
                                        </Typography>
                                    </Grid>
                                </Fragment>
                            ))
                        }
                    </>
                );
            case MOVING_SERVICE?.code:
                return (
                    <>
                        <Grid size={{xs: 4}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '描述' : 'Description'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 4}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '长 宽 高' : 'Length Width Height'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 3}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '重量' : 'Weight'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 1}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '数量' : 'Quantity'}
                            </Typography>
                        </Grid>
                        {
                            shippingInformation?.item?.map((each, index) => (
                                <Fragment key={index}>
                                    <Grid size={{xs: 4}}>
                                        <Typography sx={{
                                            textAlign: 'left',
                                            whiteSpace: 'normal',
                                            overflowWrap: 'break-word',
                                            wordWrap: 'break-word'
                                        }}>
                                            {each?.description}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 4}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.length} {each?.width} {each?.height} {each?.dimension_unit}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 3}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.weight} {each?.weight_unit}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 1}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.quantity}
                                        </Typography>
                                    </Grid>
                                </Fragment>
                            ))
                        }
                    </>
                );
            case CAR_SHIPPING?.code:
                return (
                    <>
                        <Grid size={{xs: 4}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '品牌' : 'Make'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 4}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '型号' : 'Model'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 3}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '年份' : 'Year'}
                            </Typography>
                        </Grid>
                        <Grid size={{xs: 1}}>
                            <Typography sx={{textAlign: 'left'}}>
                                {lng === 'cn' ? '数量' : 'Quantity'}
                            </Typography>
                        </Grid>
                        {
                            shippingInformation?.vehicle?.map((each, index) => (
                                <Fragment key={index}>
                                    <Grid size={{xs: 4}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.make}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 4}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.model}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 3}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.year}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 1}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {each?.quantity}
                                        </Typography>
                                    </Grid>
                                </Fragment>
                            ))
                        }
                    </>
                );
            // case CUSTOMS_BROKERAGE?.code:
            //     return CUSTOMS_BROKERAGE;
            // case HS_CODE_LOOKUP?.code:
            //     return HS_CODE_LOOKUP;
            default:
                return ""
        }
    }

    console.log('[WordPressMultiConversationChatBot] shippingInformation', shippingInformation);

    return (
        <Grid container spacing={2}>
            <Grid size={{md: 3, xs: 12}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? '寄件人信息' : 'Shipper Information'}
                </Typography>
                <Typography sx={{textAlign: 'left'}}>
                    {lng === 'cn' ? '城市' : 'City'}: {shippingInformation?.shipper_address?.city || 'N/A'}
                </Typography>
                <Typography sx={{textAlign: 'left'}}>
                    {lng === 'cn' ? '省份/州' : 'Province/State'}: {shippingInformation?.shipper_address?.province || 'N/A'}
                </Typography>
                <Typography sx={{textAlign: 'left'}}>
                    {lng === 'cn' ? '邮政编码' : 'Postal Code'}: {shippingInformation?.shipper_address?.postalCode || 'N/A'}
                </Typography>
                <Typography sx={{textAlign: 'left'}}>
                    {lng === 'cn' ? '国家' : 'Country'}: {shippingInformation?.shipper_address?.country || 'N/A'}
                </Typography>
            </Grid>
            <Grid size={{md: 3, xs: 12}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? '收件人信息' : 'Consignee Information'}
                </Typography>
                <Typography sx={{textAlign: 'left'}}>
                    {lng === 'cn' ? '城市' : 'City'}: {shippingInformation?.consignee_address?.city || 'N/A'}
                </Typography>
                <Typography sx={{textAlign: 'left'}}>
                    {lng === 'cn' ? '省份/州' : 'Province/State'}: {shippingInformation?.consignee_address?.province || 'N/A'}
                </Typography>
                <Typography sx={{textAlign: 'left'}}>
                    {lng === 'cn' ? '邮政编码' : 'Postal Code'}: {shippingInformation?.consignee_address?.postalCode || 'N/A'}
                </Typography>
                <Typography sx={{textAlign: 'left'}}>
                    {lng === 'cn' ? '国家' : 'Country'}: {shippingInformation?.consignee_address?.country || 'N/A'}
                </Typography>
            </Grid>
            <Grid size={{md: 6, xs: 12}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? service?.listNameCN : service?.listName} {lng === 'cn' ? '信息' : 'Information'}
                </Typography>
                <Grid container spacing={0}>
                    {
                        listDataWithServiceCode(shippingInformation, service)
                    }
                </Grid>
            </Grid>
        </Grid>
    )
}